module.exports = __webpack_public_path__ + "img/1-1.ae92190d.svg";